import { useTranslation } from "next-i18next";
import styled from "@emotion/styled";
import { BottomSheet, BottomSheetRef } from "react-spring-bottom-sheet";
import { useRef } from "react";
import "react-spring-bottom-sheet/dist/style.css";
import { useSnackbar } from "notistack";
import { EVENT, send } from "@/lib/amplitude";
import useKakaoInit from "@/modules/hooks/useKaKaoInit.hooks";
import { CircularProgress } from "@mui/material";

const ShareDialog = ({
  code,
  isShareOpen,
  setIsShareOpen,
  locale,
  dubbedIdx,
  videoIdx,
  isMine,
  itemSeq,
}: any) => {
  const { t } = useTranslation();

  const url =
    typeof window !== "undefined"
      ? `${window.location.origin}${
          locale !== "en" ? `/${locale}` : ""
        }/dubbed/${code}?dl=${locale}`
      : "";

  const { enqueueSnackbar } = useSnackbar();
  const sheetRef = useRef<BottomSheetRef>();
  const inputRef = useRef<HTMLInputElement>(null);
  const [loaded] = useKakaoInit();

  const handleClickKaKao = (event) => {
    event.stopPropagation();

    send(EVENT.SHARE__DUB_VIDEO, {
      dubbed_idx: dubbedIdx,
      video_idx: videoIdx,
      is_mine: isMine,
      share_target: "kakao",
      item_seq: itemSeq,
    });

    Kakao.Link.sendScrap({ requestUrl: url });
  };

  const handleClickShare = async (event) => {
    event.stopPropagation();

    send(EVENT.SHARE__DUB_VIDEO, {
      dubbed_idx: dubbedIdx,
      video_idx: videoIdx,
      is_mine: isMine,
      share_target: "link",
      item_seq: itemSeq,
    });

    if (navigator.share) {
      await navigator.share({ url });
    } else {
      try {
        await window.navigator.clipboard.writeText(url);
        enqueueSnackbar(t("toast_copied"));
      } catch {
        const input = inputRef.current;
        if (input) {
          input.select();
          document.execCommand("copy");
          input.blur();
          enqueueSnackbar(t("toast_copied"));
        }
      }
    }
  };

  return (
    <BottomSheet
      open={isShareOpen}
      ref={sheetRef}
      onDismiss={() => setIsShareOpen(false)}
    >
      <Container>
        <Header>{t(`option_share`)}</Header>
        <OptionList>
          {loaded ? (
            <Option onClick={handleClickKaKao}>
              {t(`option_share_katalk`)}
            </Option>
          ) : (
            <CircularProgress />
          )}

          <Option onClick={handleClickShare}>{t(`option_share_link`)}</Option>
        </OptionList>
      </Container>
      <input className="sr-only" readOnly ref={inputRef} value={url} />
    </BottomSheet>
  );
};

const Container = styled.div`
  padding: 10px 16px 40px;
`;

const Header = styled.div`
  text-align: center;
  font-size: var(--fs-b1);
  line-height: var(--lh-b1);
  font-weight: 600;
`;

const OptionList = styled.ul``;

const Option = styled.li`
  padding: 16px 0;
  font-size: var(--fs-b1);
  line-height: var(--lh-b1);
  font-weight: 400;
`;

export default ShareDialog;
